import { useEffect } from "react"
import { batch, useSignal } from "@preact/signals-react"
import { useAppToast } from "@ui-seeker/app"
import { postSubmit } from "@ui-seeker/utils"

import { BACKEND_APIS, GROUPED_BY } from "@constants"
import { commonFiltersValue, isLoadingCommonFilters } from "@signals"
import { elementsInLoading, skuDetailsScores, skuDetailsScoresInLoading } from "../../@signals"


export default function useSkuDetailsProductPagesKpisData() {
	const { showToast } = useAppToast()
	
	const data = useSignal([])
	const aggregation = useSignal([GROUPED_BY.COUNTRY])
    const isLoadingProductPageKpi = useSignal(false)

	const optionSelected = useSignal(GROUPED_BY.COUNTRY)

	useEffect(() => {
		if (isLoadingCommonFilters.value) batch(() => {
			data.value = []
            isLoadingProductPageKpi.value = true
			postSubmit(`${BACKEND_APIS.SKU_DETAILS}/pp_kpi`, { ...commonFiltersValue.value, groupedBy: aggregation.value }).then(res => {
				data.value = res.data
                skuDetailsScores.value["PP Kpis"] = res.data.length > 0 && res.data[0].kpiScore !== undefined ? res.data[0].kpiScore : {}
			}).catch(() => showToast.error()
            ).finally(() => {
				isLoadingProductPageKpi.value = false
			})
		})
	}, [isLoadingCommonFilters.value]);

	const handleChangeOption = (e) => {
		optionSelected.value = e.target.value

		if (optionSelected.value === GROUPED_BY.COUNTRY)
			aggregation.value = [GROUPED_BY.COUNTRY]

		if (optionSelected.value === GROUPED_BY.RETAILER)
			aggregation.value = [GROUPED_BY.COUNTRY, GROUPED_BY.RETAILER]

		data.value = []
		isLoadingProductPageKpi.value = true
		postSubmit(`${BACKEND_APIS.SKU_DETAILS}/pp_kpi`, { ...commonFiltersValue.value, groupedBy: aggregation.value }).then(res => {
			data.value = res.data
		}).catch(() => showToast.error()
		).finally(() => {
			isLoadingProductPageKpi.value = false
		})
	}

    useEffect(() => {
		if (isLoadingProductPageKpi.value) {
			elementsInLoading.value = [...elementsInLoading.value, 'productPageKpis']
			skuDetailsScoresInLoading.value = [...skuDetailsScoresInLoading.value, "PP Kpis"]
		} else {
			elementsInLoading.value = elementsInLoading.value.filter(item => item !== 'productPageKpis')
			skuDetailsScoresInLoading.value = skuDetailsScoresInLoading.value.filter(item => item !== "PP Kpis")
		}
	}, [isLoadingProductPageKpi.value])

	return {
		data: data.value,
		aggregation: aggregation.value,
		optionSelected: optionSelected.value,
		isLoadingProductPageKpi: isLoadingProductPageKpi.value,
		handleChangeOption
	}
}